import './ProfileLabeledInput.scss';

import classNames from 'classnames';
import { arrayOf, bool, func, node, shape, string } from 'prop-types';
import React from 'react';

import PreferencesDataRow from 'components/layouts/Preferences/shared/PreferencesDataRow';
import PreferencesDataRowValue from 'components/layouts/Preferences/shared/PreferencesDataRowValue';
import ValidationDataRowLabel from 'components/layouts/Preferences/shared/ValidationDataRowLabel';

const ProfileLabeledInput = ({
  children,
  className,
  errorMessage,
  isOptional = false,
  isReadOnly = false,
  label,
  validators = [],
  mailingType,
  hasResidential
}) => {
  return (
    <div
      className={classNames('labelled-profile-input', className, {
        'field-in-error': errorMessage,
        'read-only-field': isReadOnly
      })}>
      <PreferencesDataRow>
        <ValidationDataRowLabel validators={validators} mailingType={mailingType} hasResidential={hasResidential} >
          {label}
          {isOptional && <span className="optional"> (optional)</span>}
        </ValidationDataRowLabel>
        <PreferencesDataRowValue>{children}</PreferencesDataRowValue>
      </PreferencesDataRow>
      {errorMessage && (
        <span className="mobile-error-field">{errorMessage}</span>
      )}
    </div>
  );
};

ProfileLabeledInput.propTypes = {
  children: node.isRequired,
  className: string,
  errorMessage: string,
  isOptional: bool,
  isReadOnly: bool,
  label: string.isRequired,
  validators: arrayOf(
    shape({
      field: string.isRequired,
      shouldValidate: bool.isRequired,
      validator: func.isRequired,
      value: string.isRequired
    })
  )
};

export default ProfileLabeledInput;
